import { createSlice } from "@reduxjs/toolkit"; 

const statsSlice = createSlice({ 
    name: "cropStats", 
    initialState: { 
        data: "" // Initialize data as an empty string 
    }, 
    reducers: { 
        updateData(state, action) { 
            state.data = action.payload; 
        } 
    }
}); 

export const { updateData } = statsSlice.actions; 
export default statsSlice.reducer;